<template>
  <div>
    <div class="header">
      Select origin
      <div class="user-info" v-if="user">
        <span class="username">{{ user.username }}</span>
        <a href="/api/logout" class="logout-link">Logout</a>
      </div>
    </div>
    <div class="page">
      <div>
        <Fetcher />
        <UserSearch />
        <OriginSearch />
      </div>

      <div class="origins">
        <router-link
            v-for="serverOrigin in origins"
            :to="{ path: `/origin/${serverOrigin}` }"
            :key="serverOrigin"
            class="origin">
              {{serverOrigin}}
          </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import Fetcher from '@/components/Fetcher'
import UserSearch from '@/components/UserSearch'
import OriginSearch from '@/components/OriginSearch'

export default {
  name: 'OriginList',
  components: {
    Fetcher,
    UserSearch,
    OriginSearch
  },
  mounted () {
    this.loadMore()
  },
  methods: {
    ...mapActions([
      'loadMore'
    ])
  },
  computed: {
    ...mapState([
      'origins'
    ]),
    ...mapGetters([
      'getCurrentUser'
    ]),
    user() {
      return this.getCurrentUser
    }
  }
}
</script>

<style>

.origin {
  color: inherit;
  display: block;
  cursor: pointer;
  text-decoration: none;
  background-color: #fff;
  padding: 15px;
  margin-bottom: 10px;

  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

</style>
